import React from 'react';
import Header from '../../../Reusable/Header';
import Footer from '../../../Reusable/Footer';

import ThreeStepGuide from './Page components/How it works/Steps';
import FAQs from './Page components/How it works/FAQs';
import useSEO from '../../../../hooks/useSEO';

const HOW_IT_WORKS_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How do I start a fundraiser on Yamba Africa?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Create an account, provide your details, and upload your National ID to ensure trust and transparency in every fundraiser.',
      },
    },
    {
      '@type': 'Question',
      name: 'What types of causes can I raise money for?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yamba Africa supports all causes that uplift lives, except politically driven campaigns, ensuring a safe, inclusive space for fundraising.',
      },
    },
    {
      '@type': 'Question',
      name: 'What payment methods are accepted for donations?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yamba Africa supports Airtel Money, MTN Mobile Money, and credit cards for easy and accessible giving.',
      },
    },
    {
      '@type': 'Question',
      name: 'Are there any fees for creating or donating to a fundraiser?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Creating and donating are free. A small 4.25% processing fee applies to keep the platform secure.',
      },
    },
    {
      '@type': 'Question',
      name: 'How can I withdraw the funds raised?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Funds can be withdrawn to your mobile money or bank account, with a verification process taking at most one hour.',
      },
    },
  ],
};

const Howitworks = () => {
  useSEO({
    title: 'How It Works – Start or Support a Fundraiser',
    description:
      'Learn how to start a fundraiser or donate on Yamba Africa in three simple steps. Secure payments, flexible withdrawals, and real-time updates for every campaign.',
    url: 'https://yamba.africa/how-it-works',
    keywords:
      'how to fundraise Africa, start fundraiser steps, donate Africa how, Yamba Africa guide, crowdfunding steps Africa',
    structuredData: HOW_IT_WORKS_STRUCTURED_DATA,
  });

  return (
    <div>
      <Header />
      <ThreeStepGuide />
      <FAQs />


      <Footer />
    </div>
  );
};

export default Howitworks;